import { render, staticRenderFns } from "./CartSystem.vue?vue&type=template&id=6ff2c5a9&scoped=true"
import script from "./CartSystem.vue?vue&type=script&lang=js"
export * from "./CartSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff2c5a9",
  null
  
)

export default component.exports